import React from 'react'
import MinutesReport from './minutes-report'

const MinutesReportContainer: React.FC = (props) => {
    return <MinutesReport {...props} />
}

export default MinutesReportContainer
